import { render, staticRenderFns } from "./Community.vue?vue&type=template&id=8ece12da"
import script from "./Community.vue?vue&type=script&lang=ts"
export * from "./Community.vue?vue&type=script&lang=ts"
import style0 from "./Community.vue?vue&type=style&index=0&id=8ece12da&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports